import { createOptionsFrom } from "@/lib/common/Option";

export const ViewTypeLabels = {
	List: "Table",
	Gallery: "Gallery"
} as const;

export type ViewType = keyof typeof ViewTypeLabels;

export const ViewTypeOptions = createOptionsFrom(ViewTypeLabels);
